module.exports = __webpack_public_path__ + "img/waterPpl.c6604470.png";